import { useEffect, useState } from 'react';
import * as swStore from '../../installer/pwa/swUpdateStore';

const bar = {
  position: 'fixed', insetInlineStart: 0, insetInlineEnd: 0, bottom: 0, zIndex: 9999,
  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12,
  padding: '12px 16px', background: '#0f766e', color: '#fff',
  fontFamily: 'Vazirmatn, Vazir, sans-serif', fontSize: 14, direction: 'rtl',
};
const btn = {
  background: '#fff', color: '#0f766e', border: 'none', borderRadius: 8,
  padding: '6px 14px', fontWeight: 700, cursor: 'pointer', font: 'inherit',
};

export default function UpdatePrompt() {
  const [show, setShow] = useState(false);
  useEffect(() => swStore.subscribe(() => setShow(true)), []);
  if (!show) return null;
  return (
    <div role="alert" style={bar}>
      <span>نسخه‌ی جدید در دسترس است</span>
      <button style={btn} onClick={() => swStore.applyUpdate()}>بارگذاری مجدد</button>
      <button aria-label="بستن" onClick={() => setShow(false)}
        style={{ ...btn, background: 'transparent', color: '#fff', fontWeight: 400 }}>×</button>
    </div>
  );
}
